import { Flex, FlexProps, Text, defineStyle } from '@chakra-ui/react';
import { cratName } from '../../constants/cratD2CLogoLink';
import React from 'react';

const totalDailyLimitBlockStyle = defineStyle({
  w: '100%',
  py: '24px',
  flexDirection: 'column',
  alignItems: 'center',
  border: '1px solid',
  borderColor: 'borderGrey.100',
  borderRadius: '12px',
}) as FlexProps;

type Props = {
  totalDailyLimit: string;
};

export const TotalDailyLimitBlock = React.memo(({ totalDailyLimit }: Props) => {
  return (
    <Flex {...totalDailyLimitBlockStyle}>
      <Text as={'span'} fontSize={'12px'} fontWeight={400} lineHeight={'24px'}>
        Total Daily Limit
      </Text>
      <Text as={'span'} fontSize={{ base: '16px', sm: '20px' }} fontWeight={400} lineHeight={'40px'}>
        {totalDailyLimit} {cratName}
      </Text>
    </Flex>
  );
});
